var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobLaw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 99,
    viewBox: "0 0 90 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 99,
    rx: 8,
    fill: "url(#paint0_linear_387_8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0612 47.125L59.375 35.625H62.25V32.75H47.875V29.875H45V32.75H30.625V35.625H33.5L28.8425 47.125H27.75V50H28.1813C28.6298 51.4317 29.5411 52.6737 30.7687 53.5362C31.981 54.4153 33.4401 54.8887 34.9375 54.8887C36.4349 54.8887 37.894 54.4153 39.1062 53.5362C40.3349 52.6685 41.2521 51.4288 41.7225 50H42.125V47.125H40.8313L36.03 35.625H45V58.625H39.25L38.1288 59.1425L32.3787 66.3587L33.5 68.6875H59.375L60.4963 66.3587L54.7463 59.1425L53.625 58.625H47.875V35.625H56.8738L52.0725 47.125H50.75V50H51.1812C51.6515 51.4244 52.5589 52.6642 53.7745 53.543C54.9901 54.4219 56.4519 54.8949 57.9519 54.8949C59.4519 54.8949 60.9137 54.4219 62.1292 53.543C63.3448 52.6642 64.2523 51.4244 64.7225 50H65.125V47.125H64.0612ZM37.0075 51.4663C36.3735 51.8171 35.6621 52.0049 34.9375 52.0125C34.2215 52.0087 33.5185 51.8206 32.8962 51.4663C32.2618 51.1185 31.7272 50.6136 31.3438 50H38.5312C38.151 50.6061 37.6278 51.1096 37.0075 51.4663ZM37.7262 47.125H31.9763L34.8512 40.225L37.7262 47.125ZM52.935 61.5L56.5 65.8125H36.375L39.94 61.5H52.935ZM58.0525 40.2825L60.9275 47.1825H55.1775L58.0525 40.2825ZM60.0075 51.5237C59.3789 51.888 58.664 52.0767 57.9375 52.07C57.2197 52.0802 56.5131 51.8911 55.8962 51.5237C55.2608 51.1519 54.7274 50.6284 54.3438 50H61.5312C61.1749 50.6397 60.6472 51.1674 60.0075 51.5237Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_8",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EED03E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6BE02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobLaw);
export default __webpack_public_path__ + "static/media/jobLaw.b03b92a12bcf448df066677cf1c2cb6c.svg";
export { ForwardRef as ReactComponent };